var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Family_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Family_svg__st0{fill:#262a30}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Family_svg__st0",
    d: "M28.5 35c-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5zm0-15c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zM45 55h-2v-8.6c0-3.5-2.5-6.4-5.6-6.4H19.6c-3.1 0-5.6 2.9-5.6 6.4V55h-2v-8.6c0-4.6 3.4-8.4 7.6-8.4h17.7c4.2 0 7.6 3.8 7.6 8.4V55z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Family_svg__Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Family_svg__st0",
    d: "M-3.5 29c3 0 5.5-2.5 5.5-5.5S-.5 18-3.5 18-9 20.5-9 23.5-6.5 29-3.5 29zm0-9c1.9 0 3.5 1.6 3.5 3.5S-1.6 27-3.5 27-7 25.4-7 23.5-5.4 20-3.5 20zM-14 41h2v-4.8c0-1.8 1.5-3.2 3.3-3.2H2v-2H-8.7c-2.9 0-5.3 2.3-5.3 5.2V41z",
    transform: "matrix(-1 0 0 1 48 14)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Family_svg__Group-2",
    transform: "translate(12 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Family_svg__P",
    className: "Family_svg__st0",
    d: "M16 24.6h1c1.1 0 1.6-.5 1.6-1.5s-.6-1.5-1.6-1.5h-1v3zm.1 6.4H13V19h4.9c1.3 0 2.3.4 3 1.1.7.7 1.1 1.7 1.1 3s-.4 2.3-1.1 3c-.7.7-1.7 1.1-3 1.1h-1.8V31z"
  }))));
};
export default SvgFamily;